import { IPromise } from 'angular';
import {
    IDjangoProject,
    IDjangoProjectNew,
    IDjangoProjectSummary,
    IProject,
    IProjectNew,
    IProjectSummary,
    transformIDjangoProjectSummaryToIProjectSummary,
    transformIDjangoProjectToIProject,
    transformIProjectNewToIDjangoProjectNew,
} from '../../tn.common';
import DjangoClient from '../../tn.django/django-client.service/djangoClient';

export class ProjectsRepository {
    static $inject = ['djangoClient', '$q'];
    constructor(protected djangoClient: DjangoClient) {}

    list(): IPromise<IProjectSummary[]> {
        return this.djangoClient
            .get<IDjangoProjectSummary[]>('/api/1/projects/')
            .then((summaries) =>
                summaries.map(transformIDjangoProjectSummaryToIProjectSummary)
            );
    }

    get(id: number): IPromise<IProject> {
        return this.djangoClient
            .get<IDjangoProject>(`/api/1/projects/${id}/`)
            .then(transformIDjangoProjectToIProject);
    }

    delete(id: number): IPromise<unknown> {
        return this.djangoClient.del(`/api/1/projects/${id}/`);
    }

    put(project: IProjectNew): IPromise<IProject> {
        const _project = transformIProjectNewToIDjangoProjectNew(project);
        return this.djangoClient
            .put<IDjangoProject, IDjangoProjectNew>(
                `/api/1/projects/${_project.id}/`,
                _project
            )
            .then(transformIDjangoProjectToIProject);
    }

    post(project: IProjectNew): IPromise<IProject> {
        const _project = transformIProjectNewToIDjangoProjectNew(project);
        return this.djangoClient
            .post<IDjangoProject, IDjangoProjectNew>(
                '/api/1/projects/',
                _project
            )
            .then(transformIDjangoProjectToIProject);
    }

    save(project: IProjectNew): IPromise<IProject> {
        if (project.id) {
            return this.put(project);
        }
        return this.post(project);
    }
}
